import $ from 'jquery';

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');




